import dva from 'dva';
import { Component } from 'react';
import createLoading from 'dva-loading';
import history from '@tmp/history';

let app = null;

export function _onCreate() {
  const plugins = require('umi/_runtimePlugin');
  const runtimeDva = plugins.mergeConfig('dva');
  app = dva({
    history,
    
    ...(runtimeDva.config || {}),
    ...(window.g_useSSR ? { initialState: window.g_initialData } : {}),
  });
  
  app.use(createLoading());
  (runtimeDva.plugins || []).forEach(plugin => {
    app.use(plugin);
  });
  
  app.model({ namespace: 'building', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/building.js').default) });
app.model({ namespace: 'developers', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/developers.js').default) });
app.model({ namespace: 'dictionaries', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/dictionaries.js').default) });
app.model({ namespace: 'global', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/global.js').default) });
app.model({ namespace: 'login', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/login.js').default) });
app.model({ namespace: 'menu', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/menu.js').default) });
app.model({ namespace: 'robot', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/robot.js').default) });
app.model({ namespace: 'setting', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/setting.js').default) });
app.model({ namespace: 'user', ...(require('/Users/hezhou/Development/projects/newbest/NewSeed/NewSeedWeb/src/models/user.js').default) });
  return app;
}

export function getApp() {
  return app;
}

export class _DvaContainer extends Component {
  render() {
    const app = getApp();
    app.router(() => this.props.children);
    return app.start()();
  }
}
